/*
 * The emoji picker's own words. They are core's because the picker is (`core/emoji/EmojiPicker.tsx`):
 * a chat message and a document's comment open the same panel, and each surface names the panel
 * itself through the `label` it passes ("Add a reaction"), so nothing here says what the emoji is for.
 */

export const en = {
	"emoji.search": "Find an emoji",
	"emoji.categories": "Emoji categories",
	"emoji.recent": "Recently used",
	"emoji.results": "Search results",
	"emoji.noHits": "No emoji matches that.",
	"emoji.loading": "Loading emoji …",
	"emoji.skinTone": "Skin tone",
	"emoji.tone.default": "Default skin tone",
	"emoji.tone.light": "Light skin tone",
	"emoji.tone.mediumLight": "Medium-light skin tone",
	"emoji.tone.medium": "Medium skin tone",
	"emoji.tone.mediumDark": "Medium-dark skin tone",
	"emoji.tone.dark": "Dark skin tone",
	// The nine categories Unicode groups emoji into; emojibase's own key is what maps a group to
	// its copy, and a group this build has no key for keeps the English label the data ships.
	"emoji.group.smileys": "Smileys and emotion",
	"emoji.group.people": "People and body",
	"emoji.group.nature": "Animals and nature",
	"emoji.group.food": "Food and drink",
	"emoji.group.travel": "Travel and places",
	"emoji.group.activities": "Activities",
	"emoji.group.objects": "Objects",
	"emoji.group.symbols": "Symbols",
	"emoji.group.flags": "Flags",
} as const satisfies Record<string, string>
